<template>
  <el-header class="header">
    <div class="navbar">
      <div class="container">
        <el-row>
          <el-col :md="10" :xs="24">
            <div
              class="navbar-header"
              :class="{ 'has-dropdown': isMenuVisible && isSmallScreen }"
            >
              <router-link to="/" class="navbar-brand">
                <img
                  style="
                    line-height: 50px;
                    box-sizing: border-box;
                    height: 50px;
                    max-width: 100%;
                    margin-top: 0;
                    vertical-align: middle;
                  "
                  fit="cover"
                  src="http://www.lczyfz.com/img/logo.8e5c9425.png"
                />
              </router-link>
              <div class="split hidden-xs-only">|</div>
              <div class="brand-word hidden-xs-only">
                <strong>大数据与人工智能应用赋能者</strong>
                <p style="display: block; height: 20px; text-align: center; line-height: 10px;">
                  <small>DEVELOPMENT AND SERVICE</small>
                </p>
              </div>
            </div>
            <el-button
              @click="toggleMenu"
              icon="fas fa-bars fa-lg"
              class="hidden-sm-and-up"
              ref="menuButton"
            ></el-button>
          </el-col>
          <!-- 导航菜单 -->
          <MenuNav :menuItem="menuItems" />
        </el-row>
      </div>
      <!-- 下拉菜单 -->
      <div
        v-show="isMenuVisible && isSmallScreen"
        class="dropdown-menu hidden-sm-and-up"
        :class="{ 'mobile-dropdown': isMobileSize }"
        ref="dropdownMenu"
      >
        <div
          v-for="item in menuItems"
          :key="item.index"
          class="dropdown-item"
          @click="closeMenu"
        >
          <a :href="item.to">
            {{ item.text }}
          </a>
        </div>
      </div>
    </div>
  </el-header>
</template>

<script>
import MenuNav from './MenuNav.vue'
import 'element-ui/lib/theme-chalk/display.css'
import { ref, onMounted, computed } from 'vue'
export default {
  name: 'LayoutHeader',
  components: { MenuNav },
  setup () {
    const isMenuVisible = ref(false)
    const isSmallScreen = ref(false)
    const menuButton = ref(null)
    const dropdownMenu = ref(null)

    const menuItems = ref([
      { index: '1', text: '首页', to: '/' },
      {
        index: '2',
        text: '数智一体化平台',
        to: 'https://mp.weixin.qq.com/s/Fe7L31ZLCDlnEnRYGWVM5w',
        isExternal: true
      },
      { index: '3', text: '新闻动态', to: '/NewList' },
      { index: '4', text: '解决方案', to: '/ProjectList' },
      { index: '5', text: '关于我们', to: '/AboutUs' },
      { index: '6', text: '招聘信息', to: '/GetJob' }
    ])

    const toggleMenu = () => {
      isMenuVisible.value = !isMenuVisible.value
    }

    const closeMenu = () => {
      isMenuVisible.value = false
    }

    const windowWidth = ref(window.innerWidth)

    const isMobileSize = computed(() => windowWidth.value <= 600)

    const checkScreenSize = () => {
      isSmallScreen.value = window.innerWidth < 992
      windowWidth.value = window.innerWidth
    }

    const handleClickOutside = (event) => {
      if (
        isMenuVisible.value &&
        menuButton.value &&
        dropdownMenu.value &&
        !menuButton.value.$el.contains(event.target) &&
        !dropdownMenu.value.contains(event.target)
      ) {
        closeMenu()
      }
    }

    onMounted(() => {
      window.addEventListener('resize', checkScreenSize)
      document.addEventListener('click', handleClickOutside)
      checkScreenSize()
    })

    return {
      isMobileSize,
      isMenuVisible,
      isSmallScreen,
      menuItems,
      toggleMenu,
      closeMenu,
      menuButton,
      dropdownMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;

  .navbar {
    background-image: url(@/assets/images/bg-hd.jpg) !important;
    background-position: center center;
    background-size: 100%;
    border-radius: 0px;
    min-height: 62px;
    border: none;
    margin-bottom: 20px;
    position: relative;
  }

  .container {
    padding: 0 15px;
    margin: 0 auto;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1170px;
    }

    .el-row {
      position: relative;
      margin-left: -8px;
      min-height: 1px;

      .el-col {
        float: left;
        position: relative;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;
      }
    }

    .navbar-header {
      @media (min-width: 768px) {
        float: left;
      }

      .navbar-brand {
        float: left;
        cursor: pointer;
        height: 60px;
        line-height: 50px;
        padding: 7px 15px;
        font-size: 18px;
        color: #9d9d9d;
        @media (min-width: 768px) {
          margin-left: -15px;
        }
      }

      .split {
        float: left;
        line-height: 70px;
        color: #c2c2c2;
        padding: 0px 15px 0px 5px;
      }
      .brand-word {
        float: left !important;
        color: #c2c2c2;
        margin-top: 18px;

        strong {
          display: block;
          font-weight: 700;
          letter-spacing: 5px;
          font-size: 14px;
          margin-bottom: 5px;
        }
        small {
          font-size: 11.9px;
        }
      }
    }
    .el-button {
      float: right;
      width: 44px;
      height: 34px;
      padding: 9px 0;
      margin: 20px 0 8px 0;
      color: #fff;
      background-color: transparent !important;
      i.fa-bars {
        width: 22px;
        height: 14px;
      }
    }
  }
  .dropdown-menu {
    width: 100%;
    text-align: center;
    background: inherit;
    &.mobile-dropdown {
      background: #031843 !important;
    }
    .dropdown-item {
      padding: 15px;
      a {
        display: block;
        width: 100%;
        height: 20px;
        text-align: center;
        text-decoration: none;
        font-size: 15px;
        color: #e9e5e5e5;
        font-weight: bolder;
        line-height: 20px;
        &:hover {
          color: #5ef8ff !important;
        }
      }
    }
    .el-dropdown-menu__item,
    .el-menu-item {
      padding: 15px;
    }
  }
}
</style>
